import styled from 'styled-components';
import { media } from '../../../../ui';
export const Container = styled.div.withConfig({
  displayName: "Style__Container",
  componentId: "sc-190jbpb-0"
})(["margin-top:140px;", ""], media.md`
    margin: 0;
  `);
export const Content = styled.div.withConfig({
  displayName: "Style__Content",
  componentId: "sc-190jbpb-1"
})(["width:56%;margin:auto;button{font-size:", "px;", "}", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.lg, media.sm`
      width: 100%;
      font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.h6}px;
      border-radius: 6px;
    `, media.md`
    width: 98%;
    margin: 0;
  `);
export const Title = styled.div.withConfig({
  displayName: "Style__Title",
  componentId: "sc-190jbpb-2"
})(["font-size:", "px;line-height:1.16;", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.h2, media.md`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.h4}px;
    line-height: 1.15;
  `);
export const Description = styled.div.withConfig({
  displayName: "Style__Description",
  componentId: "sc-190jbpb-3"
})(["margin:10px 0 44px;font-size:", "px ", ";"], ({
  theme: {
    fontSize
  }
}) => fontSize.h6, media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.lg}px
  `);